import { render, staticRenderFns } from "./ProfileTaskList.vue?vue&type=template&id=13a607d4&scoped=true"
import script from "./ProfileTaskList.vue?vue&type=script&lang=js"
export * from "./ProfileTaskList.vue?vue&type=script&lang=js"
import style0 from "./ProfileTaskList.vue?vue&type=style&index=0&id=13a607d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a607d4",
  null
  
)

export default component.exports